<qpx-preview-toolbar ariaLabel="Image controls">
    <ng-container ngProjectAs="[previewToolbarStart]">
        @if (controlsVisible() && leftPanels().length) {
            <qpx-preview-control-group>
                <qpx-preview-panel-buttons
                    [panels]="leftPanels()"
                    [activePanelId]="activeLeftPanelId()"
                    (panelToggle)="panelToggle.emit($event)"
                />
            </qpx-preview-control-group>
        }
    </ng-container>

    <ng-container ngProjectAs="[previewToolbarCenter]">
        @if (controlsVisible()) {
            <qpx-preview-control-group>
                <qpx-preview-zoom-control
                    ariaLabel="Image zoom"
                    optionsId="image-zoom-options"
                    [zoom]="zoom()"
                    (zoomOut)="zoomOut.emit()"
                    (zoomIn)="zoomIn.emit()"
                    (zoomReset)="zoomReset.emit()"
                    (zoomSelect)="zoomSelect.emit($event)"
                />
            </qpx-preview-control-group>

            <qpx-preview-control-group>
                @if (!mobile()) {
                    <button
                        qpxButton
                        matIconButton
                        [size]="mobile() ? 'sm' : 'md'"
                        context="secondary"
                        tone="muted"
                        aria-label="Rotate image clockwise"
                        qpxTooltip="Rotate image clockwise"
                        matTooltipPosition="below"
                        (click)="rotateClockwise.emit()"
                    >
                        <ng-icon qpx name="lucideRotateCw" />
                    </button>
                }
                <button
                    qpxButton
                    matIconButton
                    [size]="mobile() ? 'sm' : 'md'"
                    [context]="handTool() ? undefined : 'secondary'"
                    tone="muted"
                    [attr.aria-label]="handToolLabel()"
                    [attr.aria-pressed]="handTool()"
                    [class.active]="handTool()"
                    [qpxTooltip]="handToolLabel()"
                    matTooltipPosition="below"
                    (click)="handToolToggle.emit()"
                >
                    <ng-icon qpx name="lucideHand" />
                </button>
            </qpx-preview-control-group>

            <qpx-preview-control-group>
                @if (!mobile()) {
                    <button
                        qpxButton
                        matIconButton
                        [size]="mobile() ? 'sm' : 'md'"
                        context="secondary"
                        tone="muted"
                        aria-label="Download image"
                        qpxTooltip="Download image"
                        matTooltipPosition="below"
                        (click)="download.emit()"
                    >
                        <ng-icon qpx name="lucideDownload" />
                    </button>
                }

                <qpx-preview-action-buttons
                    [actions]="mobile() ? overflowActions() : actions()"
                />
            </qpx-preview-control-group>
        }
    </ng-container>

    <ng-container ngProjectAs="[previewToolbarEnd]">
        <qpx-preview-control-group>
            @if (controlsVisible()) {
                <qpx-preview-pane-buttons
                    [choices]="rightPaneChoices()"
                    menuLabel="Right pane options"
                />
            }

            <button
                qpxButton
                matIconButton
                [size]="mobile() ? 'sm' : 'md'"
                context="secondary"
                tone="muted"
                [attr.aria-label]="controlsLabel()"
                [attr.aria-pressed]="controlsVisible()"
                [qpxTooltip]="controlsLabel()"
                matTooltipPosition="below"
                (click)="controlsToggle.emit()"
            >
                <ng-icon
                    qpx
                    [name]="controlsVisible() ? 'lucideEye' : 'lucideEyeOff'"
                />
            </button>

            <button
                qpxButton
                matIconButton
                [size]="mobile() ? 'sm' : 'md'"
                context="secondary"
                tone="muted"
                aria-label="Close preview"
                qpxTooltip="Close preview"
                matTooltipPosition="below"
                (click)="closePreview.emit()"
            >
                <ng-icon qpx name="lucideX" />
            </button>
        </qpx-preview-control-group>
    </ng-container>
</qpx-preview-toolbar>
